// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './address.model';
export * from './brand.model';
export * from './creditor.model';
export * from './email.model';
export * from './sizes.model';
export * from './client-stat.model';
export * from './paid-by.model';
export * from './status.model';
export * from './template.model';
export * from './upload-file.model';
export * from './view-mode';
// @endindex